// Supports validations for passing fields via nested_attributes on the back-end
function filterDestroyed(arr) {
  return arr.filter(({ _destroy }) => !_destroy)
}

export default filterDestroyed
